'use client';
import { consumeLoginAttemptForSessionTransition } from '#pplx/frontend/apps/ask/auth/loginAttemptCorrelation.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useEffect, useRef } from 'react';
const loginSucceededEvent = EVENT_PAYLOAD;
export function LoginSuccessSideEffects() {
    const { status } = useSession();
    const { enabled, track } = useInstrumentation();
    const previousStatusRef = useRef('loading');
    const pendingAuthenticationRef = useRef(null);
    useEffect(() => {
        const previousStatus = previousStatusRef.current;
        previousStatusRef.current = status;
        if (status === 'unauthenticated') {
            pendingAuthenticationRef.current = null;
            consumeLoginAttemptForSessionTransition({ previousStatus, status });
            return;
        }
        if (status !== 'authenticated') {
            pendingAuthenticationRef.current = null;
            return;
        }
        if (previousStatus !== 'authenticated') {
            pendingAuthenticationRef.current = previousStatus;
        }
        if (!enabled || !pendingAuthenticationRef.current) {
            return;
        }
        const completedAttempt = consumeLoginAttemptForSessionTransition({
            previousStatus: pendingAuthenticationRef.current,
            status,
        });
        pendingAuthenticationRef.current = null;
        if (completedAttempt) {
            track(loginSucceededEvent({ name: 'login succeeded', data: completedAttempt }));
        }
    }, [enabled, status, track]);
    return null;
}
//# sourceMappingURL=LoginSuccessSideEffects.js.map